import ApiService from '@/utils/ApiService';
import {SE_SYNC_TYPES} from '@/models/SE_SYNC_TYPES';
import {TOASTS_TYPES} from '@/models/TOASTS_TYPES';
import ToastUtils from '@/utils/ToastUtils';
import useI18nGlobal from '@/utils/i18n';
import VisibilityUtils from '@/services/canvas/utils/VisibilityUtils';

const {createToastFromStore} = ToastUtils();
const {i18n} = useI18nGlobal();
const {t} = i18n.global;
const { convertVisibilityToOriginalProperty } = VisibilityUtils();

import { getMapAreaService } from '@/modules/map-editor/composables/useMapArea';

export default {
	namespaced: true,
	state: {
		saveVisibilityTimeout: null,
		nodesVisibilityOrder: {}
	},
	getters: {
		getRawNodes(state, getters, rootState, rootGetters){
			return rootGetters['nodes/getRawNodes'];
		},
		getNodes(state, getters, rootState, rootGetters){
			return rootGetters['nodes/getNodes'];
		},
		getCurrentMap(state, getters, rootState, rootGetters) {
			return rootGetters['maps/getCurrentMap']
		},
		getMapsURL(state, getters, rootState, rootGetters){
			return rootGetters['maps/getMapsURL']
		},
		getElementsURL(state, getters, rootState, rootGetters) {
			return rootGetters['maps/getElementsURL']
		},
	},
	mutations: {
		UPDATE_NODE_ORIGINAL_VISIBILITY(state, {visibilityOriginal, nodeOriginal}){
			Object.assign(nodeOriginal.visibility, visibilityOriginal);
		},
	},
	actions: {
		nodeVisibilityUpdate({commit, getters, dispatch}, {id, visibility}){
			// update node
			commit('nodes/UPDATE_NODE', {id, nodeData: visibility}, {root: true});
			// update edges related visibility
			dispatch('edges/visibility/edgeChangeVisibilityByNode', {id, ...visibility}, {root: true});
			// update node on layer settings
			dispatch('layers/layersNodeVisibilityUpdate', {id, ...visibility}, {root: true});
			// set updated date of map changing
			dispatch('maps/mapCurrentSetUpdatedDate', new Date().toISOString(), {root: true});
			
			getMapAreaService().updateElement(true, parseInt(id));
		},
		nodeOriginalVisibilityUpdate({commit, getters}, {id, visibility}){
			const {visibilityMin, visibilityMax} = visibility;
			const nodeOriginal = getters.getRawNodes.find(node => node.id === parseInt(id));
			// convert properties to original ones
			const visibilityOriginal = {
				...convertVisibilityToOriginalProperty({visibilityMin}),
				...convertVisibilityToOriginalProperty({visibilityMax})
			};
			commit('UPDATE_NODE_ORIGINAL_VISIBILITY', {visibilityOriginal, nodeOriginal}); // update node original
		},
		nodeVisibilitySave({state, getters, dispatch}, {id, visibility}){
			// nodeVisibilityOrder doesn't make sense TODO get rid of it?
			Object.assign(state.nodesVisibilityOrder, visibility);
			clearTimeout(state.saveVisibilityTimeout);
			state.saveVisibilityTimeout = setTimeout(async () => {
				const mapsURL = getters.getMapsURL;
				const elementsURL = getters.getElementsURL;
				const mapId = getters.getCurrentMap.id;
				const nodes = getters.getNodes;
				const node = nodes.find(node => node.id === parseInt(id));
				
				const {visibilityMin, visibilityMax} = state.nodesVisibilityOrder;
				const visibilityOriginal = {
					...convertVisibilityToOriginalProperty({visibilityMin}),
					...convertVisibilityToOriginalProperty({visibilityMax})
				};
				const data = {
					nodes: [{id, visibility: visibilityOriginal}]
				};
				
				try{
					state.nodesVisibilityOrder = {};
					await ApiService.patch(`${mapsURL}${mapId}${elementsURL}`, data);
					// updated original value
					dispatch('nodeOriginalVisibilityUpdate', {id, visibility})
					// add SE to avoid saving related edges visibility twice
					const editsData = {
						type: SE_SYNC_TYPES.NODE_VISIBILITY_UPDATED,
						data: {id, visibility}
					}
					dispatch('simultaneousEditing/syncEdits', editsData, {root: true});
					// clearTimeout(state.saveVisibilityTimeout);
					await createToastFromStore(TOASTS_TYPES.SUCCESS, t('message.nodeVisibilitySuccess', {id}), dispatch);
					// send request to save edgesRelated visibility with null payload
					// since payload has been made by dispatch('edgeChangeVisibilityByNode')
					if(node.edgesFrom.length || node.edgesTo.length) {
						await dispatch('edges/visibility/edgeVisibilitySave', null, {root: true});
					}

				} catch(err){
					// update local value
					const nodeOriginal = getters.getRawNodes.find(node => node.id === parseInt(id));
					const visibility = {
						visibilityMin: nodeOriginal.visibility.min_level,
						visibilityMax: nodeOriginal.visibility.max_level
					}
					dispatch('nodeVisibilityUpdate', {id, visibility});
					// send request to fix value on server
					const visibilityOriginal = {
						...convertVisibilityToOriginalProperty({visibilityMin: visibility.visibilityMin}),
						...convertVisibilityToOriginalProperty({visibilityMax: visibility.visibilityMax})
					};
					const data = {
						nodes: [{id, visibility: visibilityOriginal}]
					};
					try{
						await ApiService.patch(`${mapsURL}${mapId}${elementsURL}`, data);
						await createToastFromStore(TOASTS_TYPES.WARNING, t('message.nodeVisibilityRestored', {id}), dispatch);
					}catch(err){
						await createToastFromStore(TOASTS_TYPES.ERROR, t('message.nodeVisibilityError', {id}), dispatch);
					}
				}
			}, 700)
		},
	}
}
